import * as React from 'react';
import { Pulses, TotalRuntime } from '../dataflow/Sidebar';
import './PerfViewer.css';
import { Flame } from './FlameChart';
import { useRecomputeLayout } from '../dataflow/layoutSlice';
import { Cytoscape } from '../dataflow/Cytoscape';
import { Popup } from '../dataflow/Popup';
import { NodesList } from '../dataflow/NodesList';
/**
 * Wrap the component so we can catch the errors. We don't use the previously defined
 * error boundary component, since we want to seperate errors in graph generation from
 * errors in spec rendering
 * **/
export class PerfViewer extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            error: null,
        };
    }
    componentDidCatch(error) {
        this.setState({ error });
    }
    render() {
        if (this.state.error) {
            return React.createElement("div", { id: "error-indicator" }, this.state.error.message);
        }
        return (React.createElement("div", { className: "perf-pane" },
            React.createElement("div", { className: "sidebar" },
                React.createElement(TotalRuntime, null),
                React.createElement(Pulses, null),
                React.createElement(NodesList, null)),
            React.createElement("div", { className: "perf-chart" },
                React.createElement(FlameChart, null),
                React.createElement(Graph, null))));
    }
}
export function Graph() {
    // Trigger starting the async layout computation, when this node is rendered
    useRecomputeLayout();
    const cytosc = React.useMemo(() => React.createElement(Cytoscape, null), []);
    return (React.createElement("div", { className: "chart" },
        cytosc,
        React.createElement(Popup, null)));
}
export function FlameChart() {
    const flame_chart = React.useMemo(() => React.createElement(Flame, null), []);
    return React.createElement("div", { className: "flame-chart" }, flame_chart);
}
